export default {
  data() {
    return {
      _widgetId: null,
      _visibleWidgetId: null,
      _tokenResolver: null,
      turnstileNeedsInteraction: false,
    }
  },

  mounted() {
    const init = () => {
      const el = this.$refs.turnstileWidget
      if (!el) return
      this._widgetId = window.turnstile.render(el, {
        sitekey: window.TURNSTILE_SITE_KEY || '',
        callback: token => {
          if (this._tokenResolver) { this._tokenResolver(token); this._tokenResolver = null }
        },
        'error-callback': () => {
          // Invisible challenge failed — switch to visible widget
          if (this._tokenResolver) {
            this._switchToVisibleWidget()
          }
        },
        execution: 'execute',
        size: 'invisible',
      })
    }
    if (window.turnstile) {
      this.$nextTick(init)
    } else {
      document.addEventListener('turnstile-ready', () => this.$nextTick(init), { once: true })
    }
  },

  beforeDestroy() {
    if (this._widgetId !== null && window.turnstile) {
      window.turnstile.remove(this._widgetId)
      this._widgetId = null
    }
    if (this._visibleWidgetId !== null && window.turnstile) {
      window.turnstile.remove(this._visibleWidgetId)
      this._visibleWidgetId = null
    }
  },

  methods: {
    // Show visible widget and wait for user interaction
    _switchToVisibleWidget() {
      this.turnstileNeedsInteraction = true
      this.$nextTick(() => {
        const el = this.$refs.turnstileVisible
        if (!el || !window.turnstile) {
          // No visible widget in template — fail gracefully
          if (this._tokenResolver) { this._tokenResolver(''); this._tokenResolver = null }
          return
        }
        if (this._visibleWidgetId !== null) {
          window.turnstile.remove(this._visibleWidgetId)
          this._visibleWidgetId = null
        }
        this._visibleWidgetId = window.turnstile.render(el, {
          sitekey: window.TURNSTILE_SITE_KEY || '',
          size: 'normal',
          callback: token => {
            this.turnstileNeedsInteraction = false
            if (this._tokenResolver) { this._tokenResolver(token); this._tokenResolver = null }
          },
          'error-callback': () => {
            if (this._tokenResolver) { this._tokenResolver(''); this._tokenResolver = null }
          },
          'expired-callback': () => {
            if (this._visibleWidgetId !== null && window.turnstile) {
              window.turnstile.reset(this._visibleWidgetId)
            }
          },
        })
      })
    },

    _getTurnstileToken(timeoutMs = 8000) {
      if (!window.turnstile) return Promise.resolve('')
      if (this._widgetId === null) return Promise.resolve('')

      return new Promise(resolve => {
        // Set resolver — called by invisible callback, visible callback, or timeout
        this._tokenResolver = resolve

        window.turnstile.reset(this._widgetId)
        window.turnstile.execute(this._widgetId)

        // Safety net: if Cloudflare doesn't respond (Safari, VPN, ad-blocker)
        // — show visible widget so user can verify manually
        setTimeout(() => {
          if (this._tokenResolver !== resolve) return // already resolved
          this._switchToVisibleWidget()
        }, timeoutMs)
      })
    },
  },
}
